import { Modal, Box, SpaceBetween, Button } from '@amzn/awsui-components-console';
import React from 'react';

/**
 * Placeholder for DeleteAlarmRuleModal — will be fully implemented in task 5.1.
 */
export default function DeleteAlarmRuleModal({ visible, onDismiss, onConfirm, loading }) {
    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            header="Delete alarm rule"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={onDismiss}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={onConfirm} loading={loading} disabled={loading}>
                            Delete
                        </Button>
                    </SpaceBetween>
                </Box>
            }
        >
            Are you sure you want to delete this alarm rule?
        </Modal>
    );
}
